import { pageHead } from "@/lib/routeHead";
import { createFileRoute } from "@tanstack/react-router";
import RiskCompliancePage from "@/pages/admin/RiskCompliancePage";

export const Route = createFileRoute("/_admin/admin/risk-compliance")({
  head: () => pageHead("Admin · Risk Compliance", "AKIVA admin · risk compliance portal.", "/admin/risk-compliance", true),
  component: RiskCompliancePage,
});
